import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '../components/Button';
import Typography from '../components/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.secondary.light,
    overflow: 'hidden',
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(15),
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 5),
  },
  title: {
    marginBottom: theme.spacing(14),
  },
  number: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  image: {
    height: 55,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  curvyLines: {
    pointerEvents: 'none',
    position: 'absolute',
    top: -180,
    opacity: 0.7,
  },
  button: {
    marginTop: theme.spacing(8),
  },
});

function ProductHowItWorks(props) {
  const { classes, language} = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <img
          src="/static/productCurvyLines.png"
          className={classes.curvyLines}
          alt="curvy lines"
        />
        <Typography variant="h4" marked="center" className={classes.title} component="h2">
          {language==="en-US"?"How it works":"Caranya..."}
        </Typography>
        <div>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6} lg={3}>
              <div className={classes.item}>
                <div className={classes.number}>1.</div>
                <img
                  src="/static/productHowItWorks1.svg"
                  alt="suitcase"
                  className={classes.image}
                />
                <Typography variant="h5" align="center">
                {language==="en-US"?"Register and choose your bussines":"Daftar dan tentukan jenis usahamu"}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <div className={classes.item}>
                <div className={classes.number}>2.</div>
                <img
                  src="/static/good.svg"
                  alt="graph"
                  className={classes.image}
                />
                <Typography variant="h5" align="center">
                {language==="en-US"?"Add your bussiness assets":"Isi semua data usaha awal yang telah dimiliki"}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <div className={classes.item}>
                <div className={classes.number}>3.</div>
                <img
                  src="/static/transaction.svg"
                  alt="clock"
                  className={classes.image}
                />
                <Typography variant="h5" align="center">
                  {language==="en-US"?
                  "Do your daily transaction on our system"
                  :
                  "Jalankan setiap transaksi harianmu di sistem kami"
                  }
                  
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <div className={classes.item}>
                <div className={classes.number}>4.</div>
                <img
                  src="/static/bars.svg"
                  alt="clock"
                  className={classes.image}
                />
                <Typography variant="h5" align="center">
                  {language==="en-US"?
                  "Enjoy your bussines where ever you are"
                  :
                  "Nikmati pemantauan perkembangan usahamu dimanapun Anda berada"
                  }
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <Button
          color="secondary"
          size="large"
          variant="contained"
          className={classes.button}
          component="a"
          href="/signup"
        >
          {language==="en-US"?"Get started":"Daftar Sekarang"}
        </Button>
      </Container>
    </section>
  );
}

ProductHowItWorks.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductHowItWorks);